import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchServicesProviderAndPropertyDeveloperList } from "../../../../../store/actions/FilterServiceProviderandPropertyDeveloperList";

export const ServiceProviderFilter = ({ assignedTo, setAssignedTo }) => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    let loginUserId = auth.user.id;
    let role = auth.user.roles[0].role.name;
    dispatch(fetchServicesProviderAndPropertyDeveloperList(loginUserId, role));
  }, [auth, dispatch]);

  const FilterServiceProviderandPropertyDeveloperList = useSelector(
    (state) => state.FilterServiceProviderandPropertyDeveloperList
  );

  return (
    <>
      <div className="filters-modal__label">Assigned To</div>
      <select
        defaultValue=""
        onChange={(e) => setAssignedTo(e.target.value)}
        value={assignedTo}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select Assigned To
        </option>
        {FilterServiceProviderandPropertyDeveloperList.payload.length > 0 ? (
          FilterServiceProviderandPropertyDeveloperList.payload.map(
            (type, i) => (
              <option
                value={type.id}
              >{`${type.firstname}  ${type.lastname}`}</option>
            )
          )
        ) : (
          <option>No data</option>
        )}
      </select>
    </>
  );
};
